'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _regulatorEditForm = require('./regulator-edit-form.component');

var _regulatorEditForm2 = _interopRequireDefault(_regulatorEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.dashboard.regulator-edit-form', []).component('regulatorEditForm', _regulatorEditForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-edit-form/regulator-edit-form.module.js